var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"d-flex flex-row align-start pa-0 align-stretch",attrs:{"fluid":""}},[_c('bar'),_c('v-main',{attrs:{"c":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }